import React, { useEffect, useLayoutEffect, useState, useRef } from 'react';
import { Carousel, CarouselItem } from 'react-bootstrap';
// import skyangkorLogo from "../../assets/icons/skyangkor.svg";
import Footer from '../../component/Footer';
import kct_logo from '../../assets/new_main_BigLogo.png';
import diagonal from '../../assets/diagonal_bg.png';
import kct_utility_ko from '../../assets/kct_utility_ko.png';
import kct_utility_en from '../../assets/kct_utility_en.png';
import m_kct_utility_en from '../../assets/m_kct_utility_en.png';
import m_kct_utility_ko from '../../assets/m_kct_utility_ko.png';
import Dumans from '../../assets/dumans.png';
import M_CityBg1 from '../../assets/m_main.webp';
import '../../css/newMain.css';
import Header from '../../component/header';
import dogh from '../../assets/dogh.png';
import { Fade } from 'react-awesome-reveal';
import kct_membership from '../../assets/kct_membership.png';
import kct_info_kr from '../../assets/kct_info_kr.png';
import kct_info_en from '../../assets/kct_info_en.png';
import Minting from '../Minting/Minting';
import NewMainDumanM from '../../component/NewMainDumanM';
import webMain from '../../assets/web_main.webp';
import MainMinting from '../../component/MainMinting';
import { MainMinting_m } from '../../component/MainMinting_m';
import { Link, useHistory } from 'react-router-dom';
import { useRecoilState, useRecoilValue } from 'recoil';
import {
	languageSetting,
	translatedText,
} from '../../recoil-states/language-state';
import main_gif_text from '../../assets/main_text.gif';
import m_main_text_webM from '../../assets/m_main_text.gif';
import {
	decryptedData,
	encryptedData,
	_trackUserIP,
} from '../../function/functions';
import spaceImg from '../../assets/earth.png';
import {
	OAuthData,
	OAuthDataState,
	WalletState,
} from '../../recoil-states/user-state/user-OAuth';
import {
	BoxDetailModalOpen,
	isSessionSaved,
	Login,
} from '../../recoil-states/user-state/user-state';
import { isMobile } from 'react-device-detect';
import { Row, Col, Image } from 'react-bootstrap';
import Roadmap from './Roadmap';

const NewMain = ({ windowWidth, handleAuth }) => {
	const [loacalelang] = useRecoilState(languageSetting);
	const textData = useRecoilValue(translatedText);
	const [openMinting, setOpenMinting] = useState(false);
	const [openAnime, setOpenAnime] = useState(false);
	const [whiteListData, setWhiteListData] = useState({});
	const [userDataState, setUserDataState] = useRecoilState(OAuthDataState);
	const [boxDetailModalOpen, setBoxDetailModalOpen] =
		useRecoilState(BoxDetailModalOpen);
	const oauthState = useRecoilValue(WalletState);
	const [sessionSaved, setSessionSaved] = useRecoilState(isSessionSaved);
	const history = useHistory();
	const roadmap = useRef(null);
	const [userData, setUserData] = useRecoilState(OAuthData);
	const oauthUser = useRecoilValue(OAuthData);
	/**
	 * Minting 모달 열기
	 * @function openModal
	 */
	const openModal = () => {
		setOpenMinting(true);
	};

	useEffect(() => {
		if (userData && localStorage.getItem('email')?.length > 0) {
			const _userData = encryptedData(userData);
			sessionStorage.setItem('userData', _userData);
			setSessionSaved(true);
			localStorage.removeItem('email');
			localStorage.removeItem('provider');
		}
	}, [oauthUser]);

	useLayoutEffect(() => {
		// if (!localStorage.getItem('visit') && !isMobile) {
		//     history.replace('/welcome');
		// }

		if (Object.keys(OAuthData).length === 0) {
			setUserDataState(false);
		}
	}, []); //영상 수정 복사본-

	return (
		<div id='newMain' className={'visit_first_opacity'}>
			{openMinting ? (
				<Minting
					setOpenMinting={setOpenMinting}
					windowWidth={windowWidth}
					textData={textData}
					language={loacalelang}
				/>
			) : null}
			<Header
				colortype={'black'}
				handleAuth={handleAuth}
				windowWidth={windowWidth}
				roadmap={roadmap}
			/>
			<div
				className='newMain_container_background'
				style={{ flex: 1, overflow: 'hidden' }}>
				<div className='newMain_container'>
					<div className='newMain_content'>
						<div
							className='newMain_top_content'
							onClick={() => setBoxDetailModalOpen(true)}>
							{/* <img src={window.innerWidth > 1024 ? main_text_webM : m_main_text_webM} className="aa"/> */}
							<img
								src={
									window.innerWidth > 1240
										? process.env.PUBLIC_URL +
										  `../../assets/main_text.gif?date=${new Date().getTime()}`
										: process.env.PUBLIC_URL +
										  `../../assets/m_main_text.gif?date=${new Date().getTime()}`
								}
								className='aa'
							/>
							{/* <p>
                                    WELCOME TO <br /> KONNECT WORLD
                                </p> */}
						</div>
						<img
							src={window.innerWidth < 1024 ? M_CityBg1 : webMain}
							alt='newMain_cityBg'
							className='newMain_cityBg'
						/>
						{/* newMain_top_content */}
					</div>
					<div className='virtual_content'>
						<img src={spaceImg} className='space_img' />
						<div className='virtual_content_textBox'>
							<Fade direction='up' triggerOnce>
								<>
									<p>
										KONNECT WORLD
										<br />
										VIRTUAL SPACE
									</p>
									<p>
										{textData && textData.main.vitualHeader}
									</p>
									{textData && window.innerWidth < 1024 ? (
										<p style={{ whiteSpace: 'pre-wrap' }}>
											{textData &&
												textData.main.vitualinfo}
										</p>
									) : (
										<p style={{ whiteSpace: 'pre-wrap' }}>
											{textData &&
												textData.main.e_vitualinfo}
										</p>
									)}
								</>
							</Fade>
							<div className='virtual_content_btnBox'>
								<Fade
									direction='up'
									triggerOnce
									className='virtual_content_btnBox_inner'>
									<button>
										<Link
											to='/Story'
											style={{
												textDecoration: 'none',
												color: '#fff',
											}}>
											{textData.main.virtualStory} &#62;
										</Link>
									</button>
									<button
										disabled={true}
										style={{ opacity: 0.5 }}
										onClick={() => {
											whiteListData.count === 0
												? alert('minting failed')
												: openModal();
											// alert(textData && textData.header.closed);
										}}>
										{textData &&
											textData.main.vitualMinting}{' '}
										&#62;
									</button>
								</Fade>
							</div>
						</div>
						{/* virtual_content */}
					</div>
					<div className='kct_info_content'>
						<img
							src={diagonal}
							alt='diagonal_background'
							className='kct_info_diagonal_bg'
						/>
						<Fade triggerOnce>
							<img
								src={kct_logo}
								alt='kct_logo'
								className='kct_info_content_img'
							/>
						</Fade>
						<div
							className='kct_info_content_textBox'
							style={{ zIndex: '999' }}>
							<Fade direction='top-right' triggerOnce>
								<>
									<p>KCT</p>
									<p>{textData.main.infoHeader}</p>
									{window.innerWidth < 1024 ? (
										<p style={{ whiteSpace: 'pre-wrap' }}>
											{textData.main.infoBody}
										</p>
									) : (
										<p style={{ whiteSpace: 'pre-wrap' }}>
											{textData.main.e_infoBody}
										</p>
									)}
								</>
							</Fade>
							<Fade
								className='kct_info_content_button_box'
								triggerOnce>
								<button
									style={
										window.innerWidth < 1024
											? { display: 'none' }
											: { display: 'block' }
									}>
									<a
										href='https://konnect.finance/en/konnect'
										target='_blank'
										rel='noreferrer'>
										{textData.main.infoAbout} &#62;
									</a>
								</button>
							</Fade>
							{/* kct_info_content_textBox */}
						</div>
						<Fade
							className='kct_info_content_circleBox'
							triggerOnce>
							{/* <div className="kct_info_content_circleBox"> */}
							{loacalelang !== 'ko' ? (
								<img
									src={kct_info_en}
									alt='info_circle'
									className='kct_info_circleBox_img'
								/>
							) : (
								<img
									src={kct_info_kr}
									alt='info_circle'
									className='kct_info_circleBox_img'
								/>
							)}
							{/* </div> */}
						</Fade>
						{/* kct_info_content */}
					</div>

					<div className='kct_utility'>
						<Fade triggerOnce>
							<p className='kct_utility_header'>UTILITY</p>
						</Fade>
						{window.innerWidth < 1024 ? (
							<>
								<Fade triggerOnce>
									<img
										src={kct_membership}
										className='kct_utility_membership'
									/>
									<span className='kct_utility_membership_span'>
										{textData.main.getKCT}
									</span>
								</Fade>
							</>
						) : null}
						{window.innerWidth < 1024 && loacalelang == 'ko' ? (
							<Fade triggerOnce>
								<img src={m_kct_utility_ko} alt='kt_utility' />
							</Fade>
						) : null}
						{window.innerWidth > 1024 && loacalelang == 'ko' ? (
							<Fade triggerOnce>
								<img src={kct_utility_ko} alt='kt_utility' />
							</Fade>
						) : null}
						{window.innerWidth < 1024 && loacalelang == 'en' ? (
							<Fade triggerOnce>
								<img src={m_kct_utility_en} alt='kt_utility' />
							</Fade>
						) : null}
						{window.innerWidth > 1024 && loacalelang == 'en' ? (
							<Fade triggerOnce>
								<img src={kct_utility_en} alt='kt_utility' />
							</Fade>
						) : null}

						<Fade
							direction='up'
							style={{ width: '100%' }}
							triggerOnce>
							{window.innerWidth < 1024 && loacalelang == 'ko' ? (
								<p className='kct_utility_figcaption'>
									{textData.main.e_utilitySubHeader}
								</p>
							) : (
								<p className='kct_utility_figcaption'>
									{textData.main.utilitySubHeader}
								</p>
							)}
						</Fade>
						<Fade
							direction='up'
							style={{ width: '100%' }}
							triggerOnce>
							{window.innerWidth < 1024 ? (
								<p
									className='kct_utility_subtexttitle'
									style={{ whiteSpace: 'pre-wrap' }}>
									{textData.main.utilityBody}
								</p>
							) : (
								<p
									className='kct_utility_subtexttitle'
									style={{ whiteSpace: 'pre-wrap' }}>
									{textData.main.e_utilityBody}
								</p>
							)}
						</Fade>
						{/* kct_utility */}
					</div>
					<Fade triggerOnce>
						<div className='kct_partners'>
							<p className='kct_partners_header'>
								PARTNERS ON EARTH
							</p>
							<div className='kct_partners_carouselBox'>
								{/* <img src={carousel_border}/> */}
								<div className='carousel_Box_inner'>
									{window.innerWidth > 1024 ? (
										<Carousel indicators={false}>
											<CarouselItem>
												<div className='kct_partners_carousel_innerBox'>
													<ul>
														<li>
															<img
																src={require('../../assets/logo/logo_1.png')}
																alt='logo1'
															/>
														</li>
														<li>
															<img
																src={require('../../assets/logo/logo_2.png')}
																alt='logo'
															/>
														</li>
														<li>
															<img
																src={require('../../assets/logo/logo_3.png')}
																alt='logo'
															/>
														</li>
														<li>
															<img
																src={require('../../assets/logo/logo_4.png')}
																alt='logo'
															/>
														</li>
													</ul>
												</div>
											</CarouselItem>
											<CarouselItem>
												<div className='kct_partners_carousel_innerBox'>
													<ul>
														<li>
															<img
																src={require('../../assets/logo/logo_5.png')}
																alt='logo'
															/>
														</li>
														<li>
															<img
																src={require('../../assets/logo/logo_6.png')}
																alt='logo'
															/>
														</li>
														<li>
															<img
																src={require('../../assets/logo/logo_7.png')}
																alt='logo'
															/>
														</li>
														<li>
															<img
																src={require('../../assets/logo/logo_8.png')}
																alt='logo'
															/>
														</li>
													</ul>
												</div>
											</CarouselItem>
											<CarouselItem>
												<div className='kct_partners_carousel_innerBox'>
													<ul>
														<li>
															<img
																src={require('../../assets/logo/logo_9.png')}
																alt='logo'
															/>
														</li>
														<li>
															<img
																src={require('../../assets/logo/logo_10.png')}
																alt='logo'
															/>
														</li>
														<li>
															<img
																src={require('../../assets/logo/logo_11.png')}
																alt='logo'
															/>
														</li>
														<li>
															<img
																src={require('../../assets/logo/logo_12.png')}
																alt='logo'
															/>
														</li>
													</ul>
												</div>
											</CarouselItem>
											<CarouselItem>
												<div className='kct_partners_carousel_innerBox'>
													<ul>
														<li>
															<img
																src={require('../../assets/logo/logo_13.png')}
																alt='logo'
															/>
														</li>
														<li>
															<img
																src={require('../../assets/logo/logo_14.png')}
																alt='logo'
															/>
														</li>
														<li>
															<img
																src={require('../../assets/logo/logo_15.png')}
																alt='logo'
															/>
														</li>
														<li>
															<img
																src={require('../../assets/logo/logo_16.png')}
																alt='logo'
															/>
														</li>
													</ul>
												</div>
											</CarouselItem>
											<CarouselItem>
												<div className='kct_partners_carousel_innerBox'>
													<ul>
														<li>
															<img
																src={require('../../assets/logo/logo_17.png')}
																alt='logo'
															/>
														</li>
														<li>
															<img
																src={require('../../assets/logo/logo_18.png')}
																alt='logo'
															/>
														</li>
														<li>
															<img
																src={require('../../assets/logo/logo_19.png')}
																alt='logo'
															/>
														</li>
														<li>
															<img
																src={require('../../assets/logo/logo_20.png')}
																alt='logo'
															/>
														</li>
													</ul>
												</div>
											</CarouselItem>
											<CarouselItem>
												<div className='kct_partners_carousel_innerBox'>
													<ul>
														<li>
															<img
																src={require('../../assets/logo/logo_21.png')}
																alt='logo'
															/>
														</li>
														<li>
															<img
																src={require('../../assets/logo/logo_22.png')}
																alt='logo'
															/>
														</li>
														<li>
															<img
																src={require('../../assets/logo/logo_23.png')}
																alt='logo'
															/>
														</li>
														<li>
															<img
																src={require('../../assets/logo/logo_24.png')}
																alt='logo'
															/>
														</li>
													</ul>
												</div>
											</CarouselItem>
										</Carousel>
									) : (
										// mobile carousel item
										<Carousel indicators={false}>
											<CarouselItem>
												<div className='kct_partners_carousel_innerBox'>
													<ul>
														<li>
															<img
																src={require('../../assets/logo/logo_1.png')}
																alt='logo'
															/>
														</li>
														<li>
															<img
																src={require('../../assets/logo/logo_2.png')}
																alt='logo'
															/>
														</li>
														<li>
															<img
																src={require('../../assets/logo/logo_3.png')}
																alt='logo'
															/>
														</li>
													</ul>
												</div>
											</CarouselItem>
											<CarouselItem>
												<div className='kct_partners_carousel_innerBox'>
													<ul>
														<li>
															<img
																src={require('../../assets/logo/logo_4.png')}
																alt='logo'
															/>
														</li>
														<li>
															<img
																src={require('../../assets/logo/logo_5.png')}
																alt='logo'
															/>
														</li>
														<li>
															<img
																src={require('../../assets/logo/logo_6.png')}
																alt='logo'
															/>
														</li>
													</ul>
												</div>
											</CarouselItem>
											<CarouselItem>
												<div className='kct_partners_carousel_innerBox'>
													<ul>
														<li>
															<img
																src={require('../../assets/logo/logo_7.png')}
																alt='logo'
															/>
														</li>
														<li>
															<img
																src={require('../../assets/logo/logo_8.png')}
																alt='logo'
															/>
														</li>
														<li>
															<img
																src={require('../../assets/logo/logo_9.png')}
																alt='logo'
															/>
														</li>
													</ul>
												</div>
											</CarouselItem>
											<CarouselItem>
												<div className='kct_partners_carousel_innerBox'>
													<ul>
														<li>
															<img
																src={require('../../assets/logo/logo_10.png')}
																alt='logo'
															/>
														</li>
														<li>
															<img
																src={require('../../assets/logo/logo_11.png')}
																alt='logo'
															/>
														</li>
														<li>
															<img
																src={require('../../assets/logo/logo_12.png')}
																alt='logo'
															/>
														</li>
													</ul>
												</div>
											</CarouselItem>
											<CarouselItem>
												<div className='kct_partners_carousel_innerBox'>
													<ul>
														<li>
															<img
																src={require('../../assets/logo/logo_13.png')}
																alt='logo'
															/>
														</li>
														<li>
															<img
																src={require('../../assets/logo/logo_14.png')}
																alt='logo'
															/>
														</li>
														<li>
															<img
																src={require('../../assets/logo/logo_15.png')}
																alt='logo'
															/>
														</li>
													</ul>
												</div>
											</CarouselItem>
											<CarouselItem>
												<div className='kct_partners_carousel_innerBox'>
													<ul>
														<li>
															<img
																src={require('../../assets/logo/logo_16.png')}
																alt='logo'
															/>
														</li>
														<li>
															<img
																src={require('../../assets/logo/logo_17.png')}
																alt='logo'
															/>
														</li>
														<li>
															<img
																src={require('../../assets/logo/logo_18.png')}
																alt='logo'
															/>
														</li>
													</ul>
												</div>
											</CarouselItem>
											<CarouselItem>
												<div className='kct_partners_carousel_innerBox'>
													<ul>
														<li>
															<img
																src={require('../../assets/logo/logo_19.png')}
																alt='logo'
															/>
														</li>
														<li>
															<img
																src={require('../../assets/logo/logo_20.png')}
																alt='logo'
															/>
														</li>
														<li>
															<img
																src={require('../../assets/logo/logo_21.png')}
																alt='logo'
															/>
														</li>
													</ul>
												</div>
											</CarouselItem>
											<CarouselItem>
												<div className='kct_partners_carousel_innerBox'>
													<ul>
														<li>
															<img
																src={require('../../assets/logo/logo_23.png')}
																alt='logo'
															/>
														</li>
														<li>
															<img
																src={require('../../assets/logo/logo_24.png')}
																alt='logo'
															/>
														</li>
														<li>
															<img
																src={require('../../assets/logo/logo_25.png')}
																alt='logo'
															/>
														</li>
													</ul>
												</div>
											</CarouselItem>
										</Carousel>
									)}
								</div>
								<span className='carousel_caption'>
									They are partners on Earth who will create a
									mission that connects the virtual and the
									real of the earth <br />
									together with DUMAN. Accomplish missions
									faster with more partners.
								</span>
							</div>
							{/* kct_partners */}
						</div>
					</Fade>
					<div className='kct_nftmarketplace'>
						<Fade direction='up' triggerOnce>
							<p className='kct_nftmarket_header'>
								<span>NFT</span>
								<br />
								MARKETPLACE
							</p>
						</Fade>
					</div>
					<Fade triggerOnce>
						<div className='kct_dumans_Box'>
							<img
								src={Dumans}
								alt='Dumans'
								className='web_duman'
							/>
							{/* nftmarketplace */}
							<div className='dumans_m'>
								<NewMainDumanM />
							</div>
						</div>
					</Fade>
					<Fade triggerOnce>
						<div className='kct_minting'>
							<div className='main_minting_web'>
								<MainMinting
									openModal={openModal}
									textData={textData}
									loacalelang={loacalelang}
								/>
							</div>
							<div className='main_minting_m'>
								<MainMinting_m
									openModal={openModal}
									textData={textData}
									loacalelang={loacalelang}
								/>
							</div>
						</div>
					</Fade>
					<div className='kct_Roadmap col' id='roadMap' ref={roadmap}>
						<Fade direction='left' triggerOnce>
							<h1 className='kct_Roadmap_header'>ROADMAP</h1>
						</Fade>
						<Row className=''>
							{window.innerWidth >= 1200 ? (
								<Roadmap />
							) : (
								<>
									<div className='roadmap_main'>
										<p>22.2Q</p>
										<ul>
											{textData?.roadmap_22_2.text.map(
												(item, index) => {
													return (
														<div className='roadmap_content_box'>
															<li>
																<span id='roadmap_index'>
																	{String(
																		index +
																			1
																	).length ===
																	1
																		? `0${
																				index +
																				1
																		  }`
																		: index +
																		  1}
																</span>
															</li>
															<li>
																{item}
																<img
																	src={require('../../assets/complete_icon.png')}
																/>
															</li>
														</div>
													);
												}
											)}
										</ul>
									</div>
									<div className='roadmap_main'>
										<p>22.3Q</p>
										<ul>
											{textData?.roadmap_22_3.text.map(
												(item, index) => {
													return (
														<div className='roadmap_content_box'>
															<li>
																<span id='roadmap_index'>
																	{String(
																		index +
																			1
																	).length ===
																	1
																		? `0${
																				index +
																				1
																		  }`
																		: index +
																		  1}
																</span>
															</li>
															<li>
																{item}
																<img
																	src={require('../../assets/complete_icon.png')}
																/>
															</li>
														</div>
													);
												}
											)}
										</ul>
									</div>
									<div className='roadmap_main'>
										<p>22.4Q</p>
										<ul>
											{textData?.roadmap_22_4.text.map(
												(item, index) => {
													return (
														<div className='roadmap_content_box'>
															<li>
																<span id='roadmap_index'>
																	{String(
																		index +
																			1
																	).length ===
																	1
																		? `0${
																				index +
																				1
																		  }`
																		: index +
																		  1}
																</span>
															</li>
															<li>
																{item}
																<img
																	src={
																		index +
																			1 <=
																		3
																			? require('../../assets/complete_icon.png')
																			: require('../../assets/ing_img.png')
																	}
																/>
															</li>
														</div>
													);
												}
											)}
										</ul>
									</div>
									<div className='roadmap_main'>
										<p>23.1Q</p>
										<ul>
											{textData?.roadmap_23_1.text.map(
												(item, index) => {
													return (
														<div className='roadmap_content_box'>
															<li>
																<span id='roadmap_index'>
																	{String(
																		index +
																			1
																	).length ===
																	1
																		? `0${
																				index +
																				1
																		  }`
																		: index +
																		  1}
																</span>
															</li>
															<li>
																{item}
																<img
																	src={require('../../assets/plan_img.png')}
																/>
															</li>
														</div>
													);
												}
											)}
										</ul>
									</div>
									<div className='roadmap_main'>
										<p>23.2Q</p>
										<ul>
											{textData?.roadmap_23_2.text.map(
												(item, index) => {
													return (
														<div className='roadmap_content_box'>
															<li>
																<span id='roadmap_index'>
																	{String(
																		index +
																			1
																	).length ===
																	1
																		? `0${
																				index +
																				1
																		  }`
																		: index +
																		  1}
																</span>
															</li>
															<li>
																{item}
																<img
																	src={require('../../assets/plan_img.png')}
																/>
															</li>
														</div>
													);
												}
											)}
										</ul>
									</div>
									<div className='roadmap_main'>
										<p>23.3Q</p>
										<ul>
											{textData?.roadmap_23_3.text.map(
												(item, index) => {
													return (
														<div className='roadmap_content_box'>
															<li>
																<span id='roadmap_index'>
																	{String(
																		index +
																			1
																	).length ===
																	1
																		? `0${
																				index +
																				1
																		  }`
																		: index +
																		  1}
																</span>
															</li>
															<li>
																{item}
																<img
																	src={require('../../assets/plan_img.png')}
																/>
															</li>
														</div>
													);
												}
											)}
										</ul>
									</div>
								</>
							)}

							{/* <Col className="Roadmap_2q_headerBox" xxl={4} xl={4} lg={4} md={3} sm={3}>
                                    <h2>22.2Q</h2>
                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={9} sm={9}>
                                    <ul className="Roadmap_2q_textBox Roadmap_textBox">
                                        {
                                            textData?.roadmap_22_2.text.map((text, index) => {
                                                return (
                                                    <Row key={index}>
                                                        <Col>
                                                            <p className="roadmap_content">
                                                                <span>0{index + 1} / </span>
                                                                {text}
                                                                <Image className="complete_image" src={require('../../assets/complete.png')} fluid width={'10%'} />
                                                                <span className="complete_text">{textData?.roadmap_complete}</span>
                                                            </p>
                                                        </Col>
                                                    </Row>)
                                            })
                                        }
                                    </ul>
                                </Col> */}
						</Row>
						{/* <Fade direction="right" triggerOnce className="kct_Roadmap_revealBox">
                            <Row className="Roadmap_3q col">
                                <Col className="Roadmap_3q_headerBox" xxl={4} xl={4} lg={4} md={3} sm={3}>
                                    <h2>22.3Q</h2>
                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={9} sm={9}>
                                    <ul className="Roadmap_3q_textBox Roadmap_textBox">
                                        {
                                            textData?.roadmap_22_3.text.map((text, index) => {
                                                return (
                                                    <Row key={index}>
                                                        <Col>
                                                            <p className="roadmap_content">
                                                                <span>0{index + 1} / </span>
                                                                {text}
                                                                <Image className="complete_image" src={require('../../assets/complete.png')} fluid width={'10%'} />
                                                                <span className="complete_text">{textData?.roadmap_complete}</span>
                                                            </p>
                                                        </Col>
                                                    </Row>)
                                            })
                                        }
                                    </ul>
                                </Col>
                            </Row>
                        </Fade> */}
					</div>
					<div className='kct_director'>
						<div className='kct_director_text'>
							{window.innerWidth < 1024 ? (
								<p style={{ whiteSpace: 'pre-wrap' }}>
									{textData.main.doghInfo}
								</p>
							) : (
								<p style={{ whiteSpace: 'pre-wrap' }}>
									{textData.main.e_doghInfo}
								</p>
							)}
							<span>
								Creative Director <b>Vincent van Dogh</b>
							</span>
						</div>
						<div className='kct_director_img'>
							<img
								src={dogh}
								alt='vincent_van_dogh'
								className='kct_dogh'
							/>
						</div>
						<div className='kct_director_text_m'>
							<div className='kct_director_img_m'>
								<img
									src={dogh}
									alt='vincent_van_dogh'
									className='kct_dogh'
								/>
							</div>
							<p>
								<span>
									Creative Director{' '}
									<span id='dogh_m'>Vincent van Dogh</span>
								</span>
								<br />
								{textData.main.doghInfo}
							</p>
						</div>
						{/* newMain */}
					</div>

					<div className='footer_box'>
						<Footer backgroundColor={'#000'} />
						{/* footerBox */}
					</div>
					{/* newMain_container */}
				</div>
				{/* newMain_container_background */}
			</div>
			{/* newMain */}
		</div>
		// author : ydw
		// date : 2022/07/05
		// comment : 반응형 작업시 Bootstrap className 추가예정입니다.
	);
};
export default NewMain;
